import React, { useEffect, useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';
import axios from 'axios';
import { apiUrl } from '../../../util/Api';
import { useNavigate } from 'react-router-dom';
//import {useDispatch} from 'react-redux';
//import {saveUserStore} from '../../../app/slices/UserSlice';

//import {string, object} from 'yup';
import * as Yup from 'yup';


const validationSchema = Yup.object({
    tag: Yup.string().required('a tag is required.'),
    email: Yup.string().email('please enter a valid email'),
    webhook: Yup.string().url('please enter a valid url')
});

/*
const validationSchema = Yup.object({
    tag: Yup.string().required('a tag is required.'),
    email: Yup.string().email().when('webhook', {
        is: (webhook) => !webhook || webhook.length === 0,
        then: Yup.string().email().required('please enter a valid email'),
        otherwise: Yup.string()
    }),
    webhook: Yup.string().url().when('email', {
        is: (email) => !email || email.length === 0,
        then: Yup.string().url().required('please enter a valid url'),
        otherwise: Yup.string()
    })
    //email: Yup.string().email('please enter a valid email'),
    //webhook: Yup.string().url('please enter a valid url')
}, [['tag', 'email', 'webhook']]);

const validationSchema = Yup.object({
    tag: Yup.string().required('a tag is required.'),
    email: Yup.string().when('webhook', {
        is: (wh) => !wh || wh.length === 0,
        then: Yup.string().email('please enter a valid email').required('an email or webhook is required')
    }),
    webhook: Yup.string().when('email', {
        is: (em) => !em || em.length === 0,
        then: Yup.string().url('please enter a valid webhook').required('an email or webhook is required')
    })
})
*/

const GuardrailEditForm = ({ updateGuardrail, ...props }) => {
    const guardrail = props?.guardrail ? props.guardrail : null;
    const alertId = props?.guardrail?.alertId ? props.guardrail.alertId : null;
    const appKey = props?.appKey ? props.appKey : null;
    const accountKey = props?.accountKey ? props.accountKey : null;
    const tag = props?.guardrail?.tag ? props.guardrail.tag : '';
    const email = props?.guardrail?.email ? props.guardrail.email : '';
    const threshold = props?.guardrail?.threshold ? props.guardrail.threshold : '';
    const webhook = props?.guardrail?.webhook ? props.guardrail.webhook : '';
    const isActive = props?.guardrail?.isActive ? props.guardrail.isActive : 0;

    let navigate = useNavigate();

    const [errors, setErrors] = useState([]);
    const [successMsg, setSuccessMsg] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const [editFormVisible, setEditFormVisible] = useState(false)

    //show form test 
    //const formType = props?.formType ? props.formType : 'edit'; 
    

    const thresholds = [0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1];

    //const dispatch = useDispatch();
    /*
    useEffect(()=> {
        if(formType == 'add'){
            //setEditFormVisible(showForm)
            //show form 
            //hide buttons
            //change language to add vs edit 
            //change handler 
        }
    }, [formType])
    */
    const submitUpdate = (values, actions) => {
        //console.log("submitting form", values);
        setSubmitting(true)
        setErrors([]);
        setSuccessMsg(null);

        axios.post(apiUrl + '/guardrails/update', values, { withCredentials: true })
            .then((res) => {
                if (res.data.status === "ok") {
                    //if(res.data.user) {
                    //  dispatch(saveUserStore(res.data.user));
                    //}
                    setErrors([]);
                    //update info at all?
                    //set cookie
                    //setAuthentication(res.data.user, persist);
                    //dispatch?
                    //dispatch(saveUserStore(res.data.user));
                    //hide form
                    //setVisible(false);
                    setSuccessMsg('The guardrail was successfully updated.')
                    setEditFormVisible(false);
                    //console.log('values account:' + values.account)
                    let temp = { ...guardrail }
                    //let temp = JSON.parse(JSON.stringify(account));
                    temp.tag = values.tag;
                    temp.email = values.email;
                    temp.webhook = values.webhook;
                    temp.threshold = values.threshold;
                    temp.isActive = values.isActive;
                    updateGuardrail(temp);

                }
                else {
                    //console.log('an error was returned');
                    //display errors
                    //clearAuthentication();
                    //dispatch(clearUserStore());
                    let errorMsgs = [];
                    //reset TOS link?
                    //values.tosAgree = [];
                    res.data.errors.forEach((error, i) => {
                        switch (error) {
                            case 'no-permissions':
                                errorMsgs.push('You do not have permissions to edit the guardrail.');
                                break;
                            case 'email-missing':
                            case 'webhook-missing':
                            case 'email-format':
                            case 'webhook-format':
                                errorMsgs.push('Please enter a valid email address or webhook url.');
                                break;
                            default:
                                errorMsgs.push('There was an error updating the guardrail.');
                        }
                    });
                    setErrors(errorMsgs);
                }
                setSubmitting(false)
            })
            .catch((err) => {
                //console.error(err);
                //console.log('something went wrong');
                //clearAuthentication();
                //dispatch(clearUserStore());
                setErrors(['An error occurred while updating the guardrail.']);
                setSubmitting(false)
            });
    }

    const deleteGuardrail = () => {

        //setErrors([]);
        //setSuccessMsg(null);

        let options = {
            appKey: appKey,
            alertId: alertId
        }
        let isAuthError = false;
        axios.post(apiUrl + '/guardrails/delete', options, { withCredentials: true })
            .then((res) => {
                if (res.data.status === "ok") {
                    navigate(`/account/${accountKey}/guardrails/app/${appKey}`)
                }
                else {
                    let errorMsgs = [];
                    let redirectToLogin = false;
                    res.data.errors.forEach((error, i) => {
                        switch (error) {
                            case 'auth-expired':
                            case 'auth-error':
                            case 'no-auth':
                                isAuthError = true;
                                redirectToLogin = true;
                                break;
                            case 'no-permissions':
                                errorMsgs.push('You do not have permissions to delete the guardrail.');
                                break;
                            default:
                                errorMsgs.push('There was an error deleting the guardrail.');
                        }
                    });
                    if (redirectToLogin) {
                        navigate('/login/');
                        return;
                    }
                    if (!isAuthError) {
                        setErrors(errorMsgs);
                    }
                }
            })
            .catch((err) => {
                setErrors(['An error occurred while deleting the guardrail.']);
            });
    }

    //check if logged in
    return (
        <div>
            <div className='d-flex'>
                <div className='me-4'>
                    <Button onClick={() => setEditFormVisible(!editFormVisible)} size='sm'>Edit Guardrail</Button>
                </div>
                <div>
                    <Button onClick={() => deleteGuardrail(!editFormVisible)} size='sm' variant='danger'>Delete Guardrail</Button>
                </div>
            </div>

            {
                errors.length > 0 ? (
                    <Alert variant='danger' className='my-3'>
                        {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
                    </Alert>
                ) : (null)
            }
            {
                successMsg !== null ? (
                    <Alert variant='info' className='my-3'>
                        {successMsg}
                    </Alert>
                ) : (null)
            }

            {editFormVisible ? (
                <div className='chart-card mt-3'>
                    <Formik validationSchema={validationSchema}
                        onSubmit={submitUpdate}
                        initialValues={{ alertId: alertId, tag: tag, appKey: appKey, email: email, webhook: webhook, threshold: threshold, isActive: isActive }}

                    >
                        {({
                            handleSubmit,
                            handleChange,
                            handleBlur,
                            values,
                            touched,
                            isValid,
                            errors
                        }) => (
                            <Form noValidate onSubmit={handleSubmit} className='col-md-9 col-sm-9 col-lg-9'>
                                <Form.Group controlId='guardrail-tag' className='mb-3'>
                                    <Form.Label>Tag <span className='required-field'>*</span></Form.Label>
                                    <Form.Control type="text" placeholder="tag for guardrail"
                                        name="tag" value={values.tag} onChange={handleChange}
                                        isInvalid={touched.tag && errors.tag}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.tag}</Form.Control.Feedback>
                                </Form.Group>
                                {/*  <Form.Group controlId='guardrail-threshold' className='mb-3'>
              <Form.Label>Threshold <span className='required-field'>*</span></Form.Label>
              <Form.Control type="text" placeholder="threshold"
                name="threshold" value={values.threshold} onChange={handleChange}
                isInvalid={touched.threshold && errors.threshold}
              />
              <Form.Control.Feedback type="invalid">{errors.threshold}</Form.Control.Feedback>
            </Form.Group>*/}
                                <Form.Group controlId='guardrail-threshold' className='mb-3'>
                                    <Form.Label>Similarity Threshold <span className='required-field'>*</span></Form.Label>
                                    <Form.Control as="select" name="threshold" onChange={handleChange} isInvalid={touched.threshold && errors.threshold}
                                        defaultValue={threshold}>
                                        <option value="">Select one</option>
                                        {
                                            thresholds.length > 0 ? (
                                                <>
                                                    {thresholds.map((t, i) => (<option key={'thresholds.' + i} value={t} >{t}</option>))}
                                                </>
                                            ) : (null)
                                        }
                                    </Form.Control>
                                    <Form.Text className='text-muted'>How similar on a scale of 0.5 to 1 to trigger alert, with 1 being closer to an exact match.</Form.Text>
                                    <Form.Control.Feedback type="invalid">{errors.typeId}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId='guardrail-email' className='mb-3'>
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" placeholder="email to receive notification"
                                        name="email" value={values.email} onChange={handleChange}
                                        isInvalid={touched.email && errors.email}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId='guardrail-webhook' className='mb-3'>
                                    <Form.Label>Webhook </Form.Label>
                                    <Form.Control type="text" placeholder="webhook to receive notification"
                                        name="webhook" value={values.webhook} onChange={handleChange}
                                        isInvalid={touched.webhook && errors.webhook}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.webhook}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId='guardrail-status' className='mb-3'>
                                    <Form.Label>Status <span className='required-field'>*</span></Form.Label>
                                    <Form.Control as="select" name="isActive" onChange={handleChange} isInvalid={touched.isActive && errors.isActive}
                                        defaultValue={isActive}>
                                        <option value="1">Active</option>
                                        <option value="0">Disabled</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">{errors.isActive}</Form.Control.Feedback>
                                </Form.Group>
                                {/*<Form.Group controlId='guardrail-status' className='mb-3'>
                                    <Form.Check type="switch" name="isActive" label="Active" onChange={handleChange} value={1} defaultChecked={isActive == 1 ? true : false} />
                                </Form.Group>*/}
                                {submitting ? (
                                    <Button variant="info" disabled size='sm'><Spinner as="span" animation="border" size="sm" /> Updating...</Button>
                                ) : (
                                    <Button variant="primary" type="submit" size='sm'>Update Guardrail</Button>
                                )}
                            </Form>
                        )}
                    </Formik>
                </div>


            ) : (null)}


        </div>
    );
}


export default GuardrailEditForm;
